
/**
 * 所属行业
 */

export const InjuryTypeList=[
    {
        prop:"code",
        label:"代码",
        width:"150",
        isShow:false
    },
    {
        prop:"name",
        label:"行业名称",
        width:"150",
        isShow:true
    }
 ]

